
// App.js

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MotionConfig } from "motion/react";

// Device context — provides isMobile / isTablet / isDesktop to the whole app
import { DeviceProvider } from "./context/DeviceContext";

// Import components from the pages directory.
import Layout from "./pages/Layout";
import NoPage from "./pages/NoPage";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Team from "./pages/Team";
import Process from "./pages/Process.js";
import ThankYou from "./pages/ThankYou.js";

import Legal from "./pages/Legal.js";
import LegalIndex from "./pages/LegalIndex.js";
import Terms from "./pages/Terms.js";
import Privacy from "./pages/Privacy.js";



// Define the main App component that sets up the router and routes.
export default function App() {

  return (
    <DeviceProvider>
      <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          {/* Route with language parameter */}
          <Route path="/" element={<Layout />} >
            {/* Redirect / to /home */}
            <Route index element={<Navigate to="home" replace />} />
            {/* Home page route */}
            <Route path="home" element={<Home />} />
            {/* Redirect to Contact Us Page */}
            <Route path="contact" element={<Contact/>} />
            {/* Products page route */}
            <Route path="products" element={<Products/>} />
            {/* Team page route */}
            <Route path="team" element={<Team/>} />
            {/* Mission page route */}
            <Route path="process" element={<Process/>} />
            {/* Thank You for Contacting page route */}
            <Route path="thank-you" element={<ThankYou/>} />
            {/* Legal page route */}
            <Route path="legal" element={<Legal/>}>
              {/* Bare "/legal" path — resource hub, not a document */}
              <Route index element={<LegalIndex/>} />
              {/* Privacy page nested route under legal */}
              <Route path="privacy-policy" element={<Privacy/>} />
              {/* Terms page nested route under legal */}
              <Route path="terms-of-service" element={<Terms/>} />
            </Route>
            {/* Wildcard route */}
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </MotionConfig>
    </DeviceProvider>
  );
}
